import { IAppState } from 'shared/common/state/app_state';

export function selectDetectedLocation(state: IAppState) {
  return state.detectedLocation;
}
